import { atom } from 'jotai'
import type { HotFormatResponse } from '@/core/types/hotFormat.type'

export const hotFormatRawAtom = atom<HotFormatResponse | null>(null)
export const isLoadingHotFormatAtom = atom<boolean>(false)
